.indicaLabel {
  color: var(--bloom-colors-indica);
}

.cbdLabel {
  color: var(--bloom-colors-cbd);
}

.hybridLabel {
  color: var(--bloom-colors-hybrid);
}

.sativaLabel {
  color: var(--bloom-colors-sativa);
}
